const getIconStatus = (office, line) => {
	if ((office === null || office === undefined) && !line) {
		return true;
	}

	if (office === false) {
		return false;
	}

	if (office === true && line !== null && line !== undefined) {
		return !line;
	}
};

export default getIconStatus;
